import { createRef, useState } from "react";
import apiService from "services/api";
import { useHistory, useParams, Link } from "react-router-dom";
import { useNotificationContext } from "contexts";
import { ImageUpload, ProtectedLink } from "components";
import { encodeImageFileAsURL } from "utils/fileToBase64";
import { FormGroup, Label, Input, Button } from "reactstrap";
import { useQuery } from "react-query";
import useProgressBar from "components/ProgressBar/useProgressBar";
import { getFileExtension } from "utils/getFileExtension";

const EditAddPointPage = () => {
    const history = useHistory();
    const { record_id } = useParams();
    const [ProgressBar, startProgress, finishProgress] = useProgressBar();
    const [showLoading, setShowLoading] = useState(false);
    const [pointsToAdd, setPointsToAdd] = useState(0);
    const [selectedParentId, setSelectedParentId] = useState(0);
    const { data: parents, isLoading: isLoadingParents } = useQuery(
        "parent",
        () => apiService.parent.get(),
        {
            refetchOnwindowFocus: false,
            onSuccess: (data) => {
                setSelectedParentId(data.length ? data[0].id : undefined);
            },
        }
    );

    const { data: record, isLoading: isLoadingRecords } = useQuery(
        ["addPointsRecord", record_id],
        () => apiService.getAddPointsRecord(record_id),
        {
            refetchOnwindowFocus: false,
            onSuccess: (data) => {
                setPointsToAdd(data.membershipPoints);
            },
        }
    );

    const { createNotification } = useNotificationContext();
    const fileInputRef = createRef();

    const startSubmit = () => {
        setShowLoading(true);
    };

    const endSubmit = () => {
        setShowLoading(false);
    };

    const submitUpdatePoint = async (e) => {
        startSubmit();
        e.preventDefault();

        // if (!fileInputRef.current.files.length) return setShowError(true);
        // const file = fileInputRef.current.files[0];
        var invoiceImg = undefined;
        if (fileInputRef.current.files.length) {
            startProgress();
            const file = fileInputRef.current.files[0];
            invoiceImg = await encodeImageFileAsURL(file);
        }
        apiService.points
            .update(record_id, invoiceImg)
            .then(() => {
                createNotification({
                    type: "success",
                    message: "Successfully edited point record",
                });
                history.push("/coffee/add-points/");
            })
            .catch((error) =>
                createNotification({
                    type: "danger",
                    message: error.message,
                })
            )
            .finally(() => endSubmit());
    };

    return (
        <form className="content" onSubmit={submitUpdatePoint}>
            <h4 className="mb-4 text-center">Add Points</h4>
            <div className="mb-5">
                <Link to="/coffee/add-points">
                    <button className="btn btn-sm btn-info">&lt; Back</button>
                </Link>
            </div>
            <FormGroup className="mb-4">
                <Label for="exampleSelect1" className="text-white">
                    Member
                </Label>
                <Input
                    type="text"
                    value={`${record?.user?.firstName} ${record?.user?.lastName}`}
                    required
                    readOnly
                />
                {/* <Select
                    className="react-select primary is-disabled"
                    classNamePrefix="react-select"
                    {...(!isLoadingParents
                        ? {
                              value: !isLoadingParents
                                  ? findParentAndReturnValue(parents)
                                  : undefined,
                          }
                        : {})}
                    onChange={(option) => setSelectedParentId(option.value)}
                    isDisabled={true}
                    options={
                        !isLoadingParents
                            ? parents.map((parent) => ({
                                  value: parent.id,
                                  label:
                                      parent.firstName + " " + parent.lastName,
                              }))
                            : []
                    }
                    placeholder="Select Parent"
                    required
                /> */}
            </FormGroup>

            <FormGroup className="mb-4">
                <Label for="exampleEmail" className="text-white">
                    Points To Add
                </Label>
                <Input
                    type="number"
                    name="pointsToAdd"
                    value={pointsToAdd}
                    onChange={(e) => setPointsToAdd(e.target.value)}
                    required
                    readOnly
                />
            </FormGroup>
            <FormGroup>
                <Label for="exampleEmail" className="text-white">
                    Receipt
                </Label>
            </FormGroup>
            <ImageUpload
                hasButton={false}
                fileInputRef={fileInputRef}
                imgPath={
                    getFileExtension(record?.invoiceImgPath) !== "pdf"
                        ? record?.invoiceImgPath
                        : ""
                }
                // disabled={Boolean(record?.invoiceImgPath)}
                apiUrl={process.env.REACT_APP_API_URL}
                isProtected={true}
            />
            <div>
                {getFileExtension(record?.invoiceImgPath) === "pdf" && (
                    <ProtectedLink
                        href={record?.invoiceImgPath}
                        target="_blank"
                        className="badge badge-secondary"
                        label="Click To View PDF Attached"
                    />
                )}
            </div>

            {showLoading && <ProgressBar />}

            <div className="text-right">
                {showLoading ? (
                    <Button color="primary" disabled={true}>
                        <span className="spinner-border"></span>
                    </Button>
                ) : (
                    <Button color="primary" type="submit">
                        Confirm
                    </Button>
                )}
            </div>
        </form>
    );
};

export default EditAddPointPage;
